'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _TaskListView = require('../components/Tasks/TaskListView.jsx');

var _TaskListView2 = _interopRequireDefault(_TaskListView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return { tasks: state.tasks };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    cancelTask: function cancelTask(task) {
      dispatch((0, _actions.cancelTask)(task));
    }
  };
};

var TaskList = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TaskListView2.default);

exports.default = TaskList;


//////////////////
// WEBPACK FOOTER
// ./client/containers/taskList.js
// module id = 111
// module chunks = 0